import { render, staticRenderFns } from "./Capacity.vue?vue&type=template&id=3b55323f&scoped=true"
import script from "./Capacity.vue?vue&type=script&lang=js"
export * from "./Capacity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b55323f",
  null
  
)

export default component.exports